/**
 * User Model Instance
 */

define(function(require) {
    'use strict';

    var _ = require('underscore');
    var storage = require('util/storage.util');
    var core = require('core');
    var UserModel = require('modules/user/user.model');

    module.exports = UserModel.extend({

        subscribe: function() {
            UserModel.prototype.subscribe.apply(this, arguments);

            this.listenTo(core, 'user:details:hideBalance', function(data) {
                this.set('hideBalance', !data);
                core.trigger('user:toggleBalance');
            });
        },

        _saveToStorage: function() {
            storage.session.setItem('userModel', _.omit(this.toJSON(),
                'isLoggedIn', 'lowBalanceHighlight', 'showLowBalancePopup'
            ));
            core.trigger('user:model:update');
        },
    });
});
